import React from "react";
import { useSelector } from "react-redux";
import {
  dealUsesFundraisingRounds,
  getDealCapacitySelector,
} from "@state/dealCapacity";
import { RootState } from "@state/rootReducer";
import { LiveDealCard } from "../helpers";
import { DealCardShell, DealCardStat } from "./DealCardShell";
import { FundraisingGauge } from "./FundraisingGauge";

interface DealCardProps {
  card: LiveDealCard;
  onSelect: (card: LiveDealCard) => void;
}

const statsFor = (card: LiveDealCard): DealCardStat[] =>
  [
    { label: "Target return", value: card.yieldLabel },
    { label: "Risk", value: card.risk },
    { label: "Liquidity", value: card.term ?? card.distribution },
  ].filter((stat): stat is DealCardStat => Boolean(stat.value));

export const DealCard = ({ card, onSelect }: DealCardProps): JSX.Element => {
  const capacity = useSelector((state: RootState) =>
    getDealCapacitySelector(state, card.deal.id)
  );
  const showGauge = dealUsesFundraisingRounds(card.deal) && !!capacity;

  return (
    <DealCardShell
      name={card.name}
      tagline={card.assetClass}
      icon={card.icon}
      investableType={card.investableType}
      termChip={card.term}
      statusText={card.statusText}
      isaEligible={card.isaEligible}
      stats={statsFor(card)}
      onSelect={() => onSelect(card)}
      testID={`live-deals-v3-card-${card.id}`}
    >
      {showGauge && capacity ? (
        <FundraisingGauge
          capacity={capacity}
          currency={card.currency}
          testID={`fundraising-capacity-card-${card.id}`}
        />
      ) : null}
    </DealCardShell>
  );
};
